import { FormattedMessage } from 'react-intl'
import Info from 'components/shared/Info'
import { Wrapper } from './styles'
import { DefaultTheme } from 'styled-components'

interface CabanaRequirementsWarningProps {
    theme?: DefaultTheme
    hasNoMatchingTickets: boolean
}

export const CabanaRequirementsWarning = ({
    theme,
    hasNoMatchingTickets,
}: CabanaRequirementsWarningProps) => {
    const hasDarkMode = theme?.mode === 'dark'

    return (
        <Wrapper isFullWidth mt={[0, 0]} pb={[12, 32]} theme={theme}>
            <Info
                color="info"
                hasNoBackground={hasDarkMode}
                hasBorder={hasDarkMode}
            >
                <FormattedMessage
                    id="upsells.msg.cabana_requirements_warning"
                    defaultMessage="Z Caban mogą korzystać tylko osoby powyżej 16 roku życia posiadające bilet wstępu do strefy Relax. "
                />
                {hasNoMatchingTickets && (
                    <FormattedMessage
                        id="upsells.msg.cabana_requirements_unfulfilled"
                        defaultMessage="W Twoim koszyku są bilety, które nie spełniają tych warunków - pamiętaj, że te osoby nie będą mogły skorzystać z Caban."
                    />
                )}
            </Info>
        </Wrapper>
    )
}
